import React from 'react';
import { Calendar, Users, Briefcase, Plane } from 'lucide-react';

/**
 * Компонент секции деталей командировки (даты, цель, транспорт и т.д.)
 */
const TripDetailsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  employeeCategories,
  businessPurposes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calendar className="w-5 h-5 mr-2 text-indigo-500" />
        Детали командировки
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Дата начала командировки */}
        <div>
          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Дата начала
          </label>
          <input
            type="date"
            id="startDate"
            name="startDate"
            value={formData.startDate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.startDate ? 'input-error' : ''}`}
          />
          {errors.startDate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.startDate}
            </p>
          )}
        </div>

        {/* Дата окончания командировки */}
        <div>
          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Дата окончания
          </label>
          <input
            type="date"
            id="endDate"
            name="endDate"
            value={formData.endDate}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.endDate ? 'input-error' : ''}`}
          />
          {errors.endDate && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.endDate}
            </p>
          )}
        </div>

        {/* Категория сотрудника */}
        <div>
          <label htmlFor="employeeCategory" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Users className="w-4 h-4 mr-1 text-indigo-500" />
            Категория сотрудника
          </label>
          <select
            id="employeeCategory"
            name="employeeCategory"
            value={formData.employeeCategory}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {employeeCategories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name} {category.rateMultiplier !== 1.0 ? `(×${category.rateMultiplier})` : ''}
              </option>
            ))}
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            От категории сотрудника зависит размер суточных (применяется коэффициент).
          </p>
        </div>

        {/* Цель командировки */}
        <div>
          <label htmlFor="businessPurpose" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Briefcase className="w-4 h-4 mr-1 text-indigo-500" />
            Цель командировки
          </label>
          <select
            id="businessPurpose"
            name="businessPurpose"
            value={formData.businessPurpose}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {businessPurposes.map((purpose) => (
              <option key={purpose.id} value={purpose.id}>
                {purpose.name}
              </option>
            ))}
          </select>
        </div>

        {/* Тип транспорта */}
        <div>
          <label htmlFor="transportType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Plane className="w-4 h-4 mr-1 text-indigo-500" />
            Вид транспорта
          </label>
          <select
            id="transportType"
            name="transportType"
            value={formData.transportType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="plane">Самолет</option>
            <option value="train">Поезд</option>
            <option value="car">Автомобиль</option>
            <option value="bus">Автобус</option>
            <option value="other">Другое</option>
          </select>
        </div>

        {/* Тип проживания */}
        <div>
          <label htmlFor="accommodationType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Тип проживания
          </label>
          <select
            id="accommodationType"
            name="accommodationType"
            value={formData.accommodationType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="hotel">Гостиница</option>
            <option value="apartment">Аппартаменты/квартира</option>
            <option value="hostel">Хостел</option>
            <option value="other">Другое</option>
            <option value="none">Без проживания</option>
          </select>
        </div>
      </div>

      {/* Информационный блок */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
        <p className="text-xs text-blue-700 dark:text-blue-300 flex items-start">
          <Calendar className="w-4 h-4 mt-0.5 mr-2 flex-shrink-0" />
          <span>
            В соответствии с законодательством РФ, суточные начисляются за каждый день нахождения в командировке, 
            включая выходные и праздничные дни, а также дни нахождения в пути. Для командировок по России 
            суточные не облагаются НДФЛ в пределах 700 руб. (для зарубежных - 2500 руб.).
          </span>
        </p>
      </div>
    </div>
  );
};

export default TripDetailsSection;